import { Component, OnInit } from '@angular/core';
import { ServiceLayer } from '../../../services/serviceLayer';
import { DAO } from '../../../modal/DAO';

@Component({
  selector: 'app-claims',
  templateUrl: './claims.component.html',
  styleUrls: ['./claims.component.css']
})
export class ClaimComponent implements OnInit {

  constructor(private serviceLayer:ServiceLayer, public dao :DAO) { }
  public IsClaimCancel:boolean=false;
  ngOnInit(): void {
  }
  
  //=============get color code based on status============
  getColorCode(status) {
    return this.serviceLayer.getColorCode(status)
  }

}
